<template>
  <span> <v-icon v-if="hasRedirect(item)" :title="`GO TO ${truncate(item.Section)}`" @click="gotoPge(item)" class="">mdi-arrow-right </v-icon></span>
</template>
<script lang="ts">
import { defineComponent } from "vue";
import { NotificationType } from "../../definitions/constants";
import UrlHelper from "../../utils/UrlHelper";

export default defineComponent({
  components: {},
  props: {
    item: {
      type: Object,
    },
    userId: {
      type: String,
    },
    isClient: {
      type: Boolean,
      default: false,
    },
    isAdmin: {
      type: Boolean,
      default: false,
    },
    isTeamMember: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      notificationTypes: NotificationType,
    };
  },
  methods: {
    hasRedirect(item: any) {
      return (
        (item.Type === NotificationType.Info ||
          item.Type === NotificationType.Warning ||
          item.Type === NotificationType.FeedBack ||
          item.Type === NotificationType.Kudos ||
          item.Type === NotificationType.Tip) &&
        item.Section
      );
    },
    isNotificationCreator(item: any) {
      return item.CreatorUserId === this.userId;
    },
    truncate(section: any) {
      if (section && section.length > 21) {
        return section.substring(0, 21) + "...";
      } else {
        return section;
      }
    },
    getSpecificPageOfNotificationUsingHash(baseUrl: string, pickerey: string = "id") {
      if (this.item && this.item.relatedEntityId) {
        return UrlHelper().notification().createUrlHash(baseUrl, this.item.relatedEntityId, "");
      }
      return baseUrl;
    },
    getSpecificPageOfNotificationUsingQuery(baseUrl: string, pickerey: string = "id") {
      if (this.item && this.item.relatedEntityId) {
        return UrlHelper().notification().createUrlQuery(baseUrl, this.item.relatedEntityId, "", pickerey);
      }
      return baseUrl;
    },
    gotoPge(item: any) {
      let baseUrl = "/";

      if (item.Url) {
        const link = this.$router.resolve({
          path: item.Url.trim(),
        });
        if (link.name) {
          this.$router.push(item.Url.trim());
        } else {
          window.location.href = item.Url.trim();
        }
        return;
      }
      if (this.isClient) {
        baseUrl = "/";
        switch (item.Section) {
          case "commitment":
            baseUrl = this.getSpecificPageOfNotificationUsingQuery("/client/management", "commitmentId");
            break;
          case "position":
            baseUrl = this.getSpecificPageOfNotificationUsingQuery("/client/management", "positionId");
            break;
          case "":
          case "Payrun":
          case "Timesheet":
          default:
            break;
        }
        window.location.href = baseUrl;
        return;
      }
      if (this.isTeamMember) {
        baseUrl = "/";
        switch (item.Section) {
          case "Timesheet":
            baseUrl = "/timesheet/list";
            break;
          case "Payrun":
            baseUrl = this.getSpecificPageOfNotificationUsingHash("/team-member/pay-runs");
            break;
          case "commitment":
            baseUrl = "/team-member/commitments";
            break;
          case "":
          default:
            break;
        }
        window.location.href = baseUrl;
      } else if (this.isAdmin) {
        baseUrl = "/";
        switch (item.Section) {
          case "Timesheet":
            baseUrl = "/timesheet/list";
            break;
          case "Payrun":
            baseUrl = this.getSpecificPageOfNotificationUsingHash("/payRuns");
            break;
          case "position":
            baseUrl = this.getSpecificPageOfNotificationUsingHash("/job");
            break;
          case "commitment":
            baseUrl = this.getSpecificPageOfNotificationUsingHash("/commitment/listV2");
            break;
          case "vm":
            baseUrl = this.getSpecificPageOfNotificationUsingHash("/vm");
            break;
          case "":
          default:
            break;
        }
        window.location.href = baseUrl;
      }
    },
  },
});
</script>
